<div [style.background-color]="backgroundColour" [style.color]="textColour" class="container">
  <app-subscription-plans [onboarding]="false" [readOnly]="true" [hideFreePlan]="hideFree" [mobile]="mobile"
                          [hideCancelPlan]="true">
  ></app-subscription-plans>
</div>
